import { Component, inject } from '@angular/core';
import {
  GcModalComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { SharepointExportService } from '../../service/sharepoint-export.service';
import {
  exportableReportsCompletedData,
  statusForExportData,
  tableDetailsData,
} from './help-modal-data';

@Component({
  selector: 'app-help-modal',
  imports: [GcModalComponent, IpoTranslatePipe, GcTextComponent],
  templateUrl: './help-modal.component.html',
  styleUrl: './help-modal.component.scss',
})
export class HelpModalComponent {
  private readonly sharepointExportService = inject(SharepointExportService);

  exportableReportsCompletedData = exportableReportsCompletedData;
  tableDetailsData = tableDetailsData;
  statusForExportData = statusForExportData;

  closeModal = () => {
    this.sharepointExportService.setIsHelpModalOpen(false);
  };
}
